import React, { useState, useEffect } from 'react';
// import { STRINGS } from '../../constants/strings';
import { tarotCards } from '../../data/tarotCards';
import './TarotCardSelection.css';

const CardBack = () => (
  <div className="card-back-design">
    <div className="card-back-inner">
      <div className="card-back-title">Tarot</div>
      <div className="card-back-subtitle">Místico</div>
      <div className="card-back-symbol">✧</div>
    </div>
  </div>
);

const cardImageMapping = {
  'El Mago': 'magician',
  'La Sacerdotisa': 'high-priestess',
  'La Emperatriz': 'empress',
  'El Emperador': 'emperor',
  'El Sumo Sacerdote': 'hierophant',
  'Los Enamorados': 'lovers',
  'El Carro': 'chariot',
  'La Fuerza': 'strength',
  'El Ermitaño': 'hermit',
  'La Rueda de la Fortuna': 'wheel-of-fortune',
  'La Justicia': 'justice',
  'El Colgado': 'hanged-man',
  'La Muerte': 'death',
  'La Templanza': 'temperance',
  'El Diablo': 'devil',
  'La Torre': 'tower',
  'La Estrella': 'star',
  'La Luna': 'moon',
  'El Sol': 'sun',
  'El Juicio': 'judgement',
  'El Mundo': 'world',
  'El Loco': 'fool'
};

const TarotCardSelection = ({ 
  onCardSelect,
  cardCount = 5,
  displayStyle = 'fan', // 'fan', 'grid', or 'simple'
  animationDuration = 800,
}) => {
  const [cards, setCards] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isSelecting, setIsSelecting] = useState(false);
  const [isReading, setIsReading] = useState(false);

  useEffect(() => {
    const randomCards = [...tarotCards]
      .sort(() => Math.random() - 0.5)
      .slice(0, cardCount);
    setCards(randomCards);
  }, [cardCount]);

  const handleCardClick = (index) => {
    if (selectedIndex !== null || isSelecting) return;
    
    setIsSelecting(true);
    setSelectedIndex(index);
    
    setTimeout(() => {
      setIsReading(true);
      
      setTimeout(() => {
        setIsReading(false);
        onCardSelect(cards[index]);
      }, 2000);
      
    }, animationDuration);
  };

  const getCardStyle = (index) => {
    if (displayStyle === 'fan') {
      return {
        transform: `rotate(${(index - (cardCount - 1) / 2) * 5}deg)`,
        zIndex: index
      };
    }
    return {};
  };

  const getCardImagePath = (cardName) => {
    const mappedName = cardImageMapping[cardName];
    if (!mappedName) {
      console.error(`No image mapping found for card: ${cardName}`);
      return '/images/cards/card-back.png'; // Fallback image
    }
    return `/images/cards/${mappedName}.png`;
  };

  return (
    <div className={`tarot-selection-container ${displayStyle}`}>
      {/* Remove or comment out this line */}
      {/* <h2 className="selection-title">{STRINGS.CARD_SELECTION.INSTRUCTION}</h2> */}
      
      <div className="cards-display">
        {cards.map((card, index) => (
          <div 
            key={card.id} 
            className="card-wrapper"
            style={getCardStyle(index)}
          >
            <div 
              className={`tarot-card ${selectedIndex === index ? 'selected' : ''} ${
                selectedIndex !== null && selectedIndex !== index ? 'fade-out' : ''
              }`}
              onClick={() => handleCardClick(index)}
            >
              <div className="card-inner">
                <div className="card-front">
                  <CardBack />
                </div>
                <div className="card-back">
                  <div className="card-content">
                    <img 
                      src={getCardImagePath(card.name)}
                      alt={card.name}
                      className="card-image"
                    />
                    <div className="card-name">{card.name}</div>
                    {card.number && <div className="card-number">{card.number}</div>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="selection-footer">
        <p className="selection-instruction">
          {isReading 
            ? 'Leyendo tu destino en las cartas...' 
            : selectedIndex === null
              ? 'Haz clic en una carta para revelar tu destino'
              : 'Revelando los secretos del tarot...'}
        </p>
      </div>
    </div>
  );
};

export default TarotCardSelection;